import * as d3 from 'd3-selection'
import * as array from 'd3-array'
import * as scale from 'd3-scale'
import * as shape from 'd3-shape'

const thresholdRingWidth = 1.4

export default function (id, defs, dim, startAngle) {
  var draw = function (selection) {
    selection.each(function (data) {
      var scaler = scale.scaleLinear()
                        .domain(array.extent(data.thresholds || []))
                        .range([startAngle, startAngle * -1])
                        .clamp(true)
        , arc = shape.arc().innerRadius(dim.width / 2)
                           .outerRadius((dim.width / 2) - thresholdRingWidth)
                           .startAngle(function (d) {
                             return scaler(d.start) * Math.PI / 180
                           })
                           .endAngle(function (d) {
                             return scaler(d.end) * Math.PI / 180
                           })

      // Add the linear gradients only for non-highlightArcThreshold (e.g. goal only or yes/no) gauges
      if (!data.highlightArcThreshold) {
        var gradients = defs.selectAll('g.threshold-gradients')
                            .data(data.colors ? [data.colors] : [])
          , lg = gradients.enter()
                          .append('g')
                            .attr('class', 'threshold-gradients')
                            .merge(gradients)
                            .selectAll('.threshold-gradient')
                            .data(function (d) {
                              return d
                            })

        var enter = lg.enter().append('linearGradient')
                                .attr('class', 'threshold-gradient')
                                .attr('y1', '0%')
                                .attr('y2', '0%')

        // If thresholds are descending, change their gradient to be right to left
        if (data.thresholds && data.thresholds.length > 1 && data.thresholds[1] < data.thresholds[0]) {
          enter.attr('x1', '100%')
               .attr('x2', '0%')
        } else {
          enter.attr('x1', '0%')
               .attr('x2', '100%')
        }

        enter.append('stop')
               .attr('offset', '0%')
               .attr('stop-color', String)
        enter.append('stop')
               .attr('offset', '100%')
               .attr('stop-color', String)

        enter.merge(lg)
            .attr('id', (d, i) => `${id}-threshold-${i}`)

        lg.selectAll('stop')
          .attr('stop-color', String)

        lg.exit().remove()
      }

      var group = d3.select(this)
                    .selectAll('g.thresholds').data([data])
        , colors = group.enter()
                        .append('g')
                          .attr('class', 'thresholds')
                          .merge(group)
                          .selectAll('path')
                          .data(function (d) {
                            return (d.colors || []).map(function (color, i) {
                              return {
                                color: color,
                                start: d.thresholds[i],
                                end: d.thresholds[i + 1]
                              }
                            })
                          })
        , _colors = colors.enter()
                          .append('path')
                          .merge(colors)

      colors.exit().remove()

      _colors.attr('d', arc)

      if (data.highlightArcThreshold) {
        _colors.attr('class', 'highlight-arc-threshold-gauge')
               .style('fill', d => d.color)
      } else {
        // The thresholds have a gradient only for non highlightArcThreshold gauges
        _colors.attr('fill', (d, i) => `url(#${id}-threshold-${i})`)
      }
    })
  }

  return draw
}
